module.exports = __webpack_public_path__ + "img/big.873230af.png";